/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Not_Found_DescriptionInputs */

const en_agent_authorization_not_found_description = /** @type {(inputs: Agent_Authorization_Not_Found_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The link is invalid or no longer available. Ask the Agent to start a new registration.`)
};

const zh_agent_authorization_not_found_description = /** @type {(inputs: Agent_Authorization_Not_Found_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此链接无效或已不可用。请让 Agent 重新发起注册。`)
};

/**
* | output |
* | --- |
* | "The link is invalid or no longer available. Ask the Agent to start a new registration." |
*
* @param {Agent_Authorization_Not_Found_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_not_found_description = /** @type {((inputs?: Agent_Authorization_Not_Found_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Not_Found_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_not_found_description(inputs)
	return zh_agent_authorization_not_found_description(inputs)
});
export { agent_authorization_not_found_description as "agent.authorization.not_found_description" }